import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//TODO: relembrar para que serve QueryClient
import { QueryClient, QueryClientProvider } from "react-query";

import { createRoot } from 'react-dom/client';
const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render( <React.StrictMode>
    <QueryClientProvider client={queryClient} contextSharing={true}>
        <App />
    </QueryClientProvider>
</React.StrictMode>);






// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
